require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./button"), require("./flexlayout"), require("./list"), require("./itemdnd"), require("./draglayer"), require("./hspacer"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./button", "./flexlayout", "./list", "./itemdnd", "./draglayer", "./hspacer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./button"), require("./flexlayout"), require("./list"), require("./itemdnd"), require("./draglayer"), require("./hspacer")) : factory(root["./utils"], root["./button"], root["./flexlayout"], root["./list"], root["./itemdnd"], root["./draglayer"], root["./hspacer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__25__, __WEBPACK_EXTERNAL_MODULE__46__, __WEBPACK_EXTERNAL_MODULE__91__, __WEBPACK_EXTERNAL_MODULE__92__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[71],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25__;

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__46__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(582);


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Tree = _interopRequireDefault(__webpack_require__(583));

exports["default"] = _Tree["default"];
exports.Tree = _Tree["default"];

var _treeDnD = _interopRequireWildcard(__webpack_require__(584));

exports.treeDnD = _treeDnD["default"];
exports.treeItemDnD = _treeDnD.treeItemDnD;

var _TreeItem = _interopRequireDefault(__webpack_require__(585));

exports.TreeItem = _TreeItem["default"];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends4 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _list = _interopRequireWildcard(__webpack_require__(25));

var _utils = __webpack_require__(4);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sortBy = _utils.lodash.sortBy,
    forOwn = _utils.lodash.forOwn,
    findIndex = _utils.lodash.findIndex;
var multiSelect = _utils.listHelper.multiSelect,
    singleSelect = _utils.listHelper.singleSelect;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

function purge(byIdData, byIdMap) {
  forOwn(byIdData, function (v, key) {
    if (!byIdMap[key]) {
      delete byIdData[key];
    }
  });
}

function toBoolMap(byIdObjects) {
  return Object.keys(byIdObjects).reduce(function (map, id) {
    map[id] = !!byIdObjects[id];
    return map;
  }, {});
}

function computePathToRoot(node) {
  var result = '';
  var p = node;

  do {
    result = result ? p.relativeIndex + "_" + result : "" + p.relativeIndex;
    p = p.parent;
  } while (p);

  return result;
}

var Tree = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Tree, _Component);

  function Tree() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      filterCollapsedNodes: {},
      active: _this.props.activeNode ? _this.props.getId(_this.props.activeNode) : null
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOrderedSelectedNodes", function (selectedNodes) {
      if (selectedNodes === void 0) {
        selectedNodes = _this.state.selectedNodes;
      }

      var selectedMap = _this._toObjectMap(selectedNodes);

      return sortBy(Object.keys(selectedMap), function (id) {
        return _this._byIdMap[id].index;
      }).map(function (id) {
        return selectedMap[id];
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedNodes", function () {
      var selectedMap = _this._toObjectMap(_this.state.selectedNodes);

      return Object.keys(selectedMap).map(function (id) {
        return selectedMap[id];
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_activeIndex", -1);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_pivotIndex", -1);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_lastClickIndex", -1);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_byIdMap", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_data", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_prevExpandedNodes", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_flattenTree", true);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getParentIndex", function (index) {
      var id = _this._getId(index);

      var parent = _this._byIdMap[id].parent;

      if (!parent) {
        return -1;
      }

      return _this._data.indexOf(parent);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isExpandedByIndex", function (index) {
      var filter = _this.props.filter;
      var filterCollapsedNodes = _this.state.filterCollapsedNodes;

      var id = _this._getId(index);

      return filter ? !filterCollapsedNodes[id] : _this._isExpandedById(id);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isExpandedById", function (id) {
      var expandedByDefault = _this.props.expandedByDefault;
      var expandedNodes = _this.state.expandedNodes;
      return expandedByDefault ? !Object.prototype.hasOwnProperty.call(expandedNodes, id) || expandedNodes[id] : expandedNodes[id];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isSelected", function (index) {
      return _this.state.selectedNodes[_this._getId(index)];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_itemRenderer", function (index, props) {
      var treeNode = _this._data[index];
      var focusDepth = treeNode.focusDepth,
          hasChildren = treeNode.hasChildren,
          alwaysExpanded = treeNode.alwaysExpanded,
          visible = treeNode.visible,
          node = treeNode.node;

      var expanded = _this._isExpandedByIndex(index);

      var _this$props = _this.props,
          itemRenderer = _this$props.itemRenderer,
          data = _this$props.data,
          focusNode = _this$props.focusNode,
          filter = _this$props.filter;
      var treeProps = (0, _extends4["default"])({}, props, {
        node: node,
        hasChildren: hasChildren,
        alwaysExpanded: alwaysExpanded,
        depth: focusDepth,
        expanded: expanded,
        visible: visible,
        data: data,
        pathToRoot: computePathToRoot(treeNode),
        isFocusNode: !filter && focusNode && focusNode === node
      });
      return itemRenderer(node, treeProps);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onActiveChange", function (event) {
      _this.setState(function () {
        var index = event.index,
            type = event.type;
        var onActiveChange = _this.props.onActiveChange;
        var newState;

        if (type === _list.activeEventTypes.ABSOLUTE) {
          var active = _this._getId(index);

          newState = {
            active: active
          };
        } else {
          var delta = type === _list.activeEventTypes.UP ? -1 : 1;

          var _active = _this._getId(_this._activeIndex + delta);

          newState = {
            active: _active
          };
        }

        onActiveChange && onActiveChange(newState.active ? _this._byIdMap[newState.active].node : null);
        return newState;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMenu", function (x, y, e) {
      return _this.props.onMenu(x, y, _this._toObjectMap(_this.state.selectedNodes), e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onExpand", function (event) {
      var _extends2, _extends3;

      var index = event.index,
          type = event.type;
      var _this$props2 = _this.props,
          onExpand = _this$props2.onExpand,
          data = _this$props2.data,
          filter = _this$props2.filter;
      var treeNode = _this._data[index];
      var activeNode = _this._byIdMap[_this.state.active];
      var id = treeNode.id;
      var expanded;

      if (type === _list.expandEventTypes.TOGGLE) {
        expanded = !_this.state.expandedNodes[id];
      } else if (type === _list.expandEventTypes.EXPAND) {
        expanded = true;
      } else if (type === _list.expandEventTypes.COLLAPSE) {
        expanded = false;
      }

      if (!expanded && activeNode) {
        var inHierarchy = false;
        var node = activeNode;

        while (node && !inHierarchy) {
          inHierarchy = node.parent === treeNode;
          node = node.parent;
        }

        if (inHierarchy) {
          _this.setState({
            active: id,
            pivot: id,
            lastClick: id
          });
        }
      }

      var expandedNodes = (0, _extends4["default"])({}, _this.state.expandedNodes, (_extends2 = {}, _extends2[id] = expanded, _extends2));
      var filterCollapsedNodes = (0, _extends4["default"])({}, _this.state.filterCollapsedNodes, (_extends3 = {}, _extends3[id] = !expanded, _extends3));

      if (!_this.props.expandedNodes) {
        _this.setState({
          expandedNodes: expandedNodes,
          filterCollapsedNodes: filterCollapsedNodes
        });
      } else if (filter) {
        _this.setState({
          filterCollapsedNodes: filterCollapsedNodes
        });
      }

      onExpand && onExpand(expandedNodes, [treeNode.node], expanded, data);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSelectionChange", function (event) {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          filter = _this$props3.filter,
          selectionMode = _this$props3.selectionMode;
      var selectedNodes = _this.state.selectedNodes;
      var selectedMap = {};

      if (selectionMode === 'single') {
        var key = singleSelect(event, _this._data, Object.keys(selectedNodes)[0], _this._getId);

        if (key != null) {
          var _selectedMap;

          selectedMap = (_selectedMap = {}, _selectedMap[key] = true, _selectedMap);
        }
      } else {
        selectedMap = multiSelect(event, _this._data, selectedNodes, _this._getId).selectedMap;
      }

      if (!_this.props.selectedNodes) {
        _this.setState({
          selectedNodes: toBoolMap(selectedMap)
        });
      }

      if (filter) {
        var nodes = [];
        var expandedNodes = (0, _extends4["default"])({}, _this.state.expandedNodes);
        Object.keys(selectedMap).forEach(function (id) {
          var node = _this._byIdMap[id].parent;

          while (node) {
            if (!expandedNodes[node.id]) {
              expandedNodes[node.id] = true;
              nodes.push(node);
            }

            node = _this._byIdMap[node.id].parent;
          }
        });

        if (nodes.length) {
          if (!_this.props.expandedNodes) {
            _this.setState({
              expandedNodes: expandedNodes
            });
          }

          var onExpand = _this.props.onExpand;
          onExpand && onExpand(expandedNodes, nodes.map(function (n) {
            return n.node;
          }), true, data);
        }
      }

      if (event.pivot && event.index !== -1) {
        _this.setState({
          pivot: _this._getId(event.index)
        });
      }

      if (event.last != null) {
        _this.setState({
          lastClick: _this._getId(event.last)
        });
      }

      var onSelectionChange = _this.props.onSelectionChange;
      onSelectionChange && onSelectionChange(_this._toObjectMap(selectedMap), _this.getOrderedSelectedNodes(selectedMap), data);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refList", function (list) {
      _this._list = list;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getIndex", function (id) {
      return id == null ? -1 : findIndex(_this._data, function (treeNode) {
        return id === treeNode.id;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getId", function (index) {
      return _this._data[index] ? _this._data[index].id : null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_itemSizeEstimator", function (index, cache) {
      return _this.props.itemSizeEstimator(_this._data[index].node, index, cache);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_itemSizeGetter", function (index) {
      return _this.props.itemSizeGetter(_this._data[index].node, index);
    });
    return _this;
  }

  var _proto = Tree.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var _this$props4 = this.props,
        defaultSelectedNodes = _this$props4.defaultSelectedNodes,
        selectedNodes = _this$props4.selectedNodes,
        defaultExpandedNodes = _this$props4.defaultExpandedNodes,
        expandedNodes = _this$props4.expandedNodes;
    var selected = toBoolMap(selectedNodes || defaultSelectedNodes || {});
    var expanded = toBoolMap(expandedNodes || defaultExpandedNodes || {});
    this.setState({
      expandedNodes: expanded,
      selectedNodes: selected
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var filter = nextProps.filter,
        selectedNodes = nextProps.selectedNodes,
        expandedNodes = nextProps.expandedNodes,
        activeNode = nextProps.activeNode,
        isDragging = nextProps.isDragging;
    var newState = {};

    if (filter !== this.props.filter) {
      newState.filterCollapsedNodes = {};
    }

    if (selectedNodes) {
      newState.selectedNodes = toBoolMap(selectedNodes);
    }

    if (expandedNodes) {
      newState.expandedNodes = toBoolMap(expandedNodes);
    }

    if (activeNode) {
      newState.active = this.props.getId(activeNode);
    }

    if (isDragging) {
      this._flattenTree = false;
    }

    this.setState(newState);
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    var _this2 = this;

    if (nextState.expandedNodes !== this.state.expandedNodes) {
      Object.keys(nextState.expandedNodes).forEach(function (id) {
        _this2._prevExpandedNodes[id] = true;
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var byIdMap = this._byIdMap;
    var _this$state = this.state,
        expandedNodes = _this$state.expandedNodes,
        filterCollapsedNodes = _this$state.filterCollapsedNodes,
        selectedNodes = _this$state.selectedNodes;
    purge(this._prevExpandedNodes, byIdMap);
    purge(selectedNodes, byIdMap);
    purge(expandedNodes, byIdMap);
    purge(filterCollapsedNodes, byIdMap);

    if (prevState.active !== this.state.active) {
      this._list.scrollAround(this._activeIndex);
    }
  } // returns the nodes in the order in which they appear in the tree
  ;

  _proto._toFlat = function _toFlat(nodes, byIdMap, flatData, depth, focusDepth, startingIndex, parent, isFocusChild) {
    if (depth === void 0) {
      depth = 0;
    }

    if (focusDepth === void 0) {
      focusDepth = 0;
    }

    if (startingIndex === void 0) {
      startingIndex = 0;
    }

    if (parent === void 0) {
      parent = null;
    }

    if (isFocusChild === void 0) {
      isFocusChild = false;
    }

    var _this$props5 = this.props,
        getId = _this$props5.getId,
        getChildren = _this$props5.getChildren,
        getHasChildren = _this$props5.getHasChildren,
        isVisible = _this$props5.isVisible,
        filter = _this$props5.filter,
        isAlwaysExpanded = _this$props5.isAlwaysExpanded,
        focusNode = _this$props5.focusNode;
    var filterCollapsedNodes = this.state.filterCollapsedNodes;
    var prevExpandedNodes = this._prevExpandedNodes;
    var index = startingIndex;

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var id = getId(node);
      var hasChildren = void 0;
      var children = void 0;

      if (getHasChildren) {
        hasChildren = getHasChildren(node, depth, focusDepth);
      } else {
        children = getChildren(node, depth, focusDepth);
        hasChildren = !!(children && children.length);
      }

      var alwaysExpanded = isAlwaysExpanded(node, depth, i, nodes.length, focusDepth);
      var treeNode = {
        relativeIndex: i,
        node: node,
        id: id,
        depth: depth,
        focusDepth: focusDepth,
        index: index,
        parent: parent,
        hasChildren: hasChildren,
        visible: true,
        alwaysExpanded: alwaysExpanded
      };
      index += 1;
      byIdMap[id] = treeNode;

      if (filter) {
        var visible = isVisible(filter, node);
        treeNode.visible = isVisible(filter, node);

        if (hasChildren) {
          children = children || getChildren(node, depth, focusDepth) || [];
          var flatChildren = [];

          this._toFlat(children, byIdMap, flatChildren, depth + 1, depth + 1, index, treeNode);

          index += flatChildren.length;
          var filterCollapsed = filterCollapsedNodes[id];

          if (flatChildren.length || visible) {
            flatData.push(treeNode);
          }

          if (flatChildren.length && !filterCollapsed) {
            flatData.push.apply(flatData, flatChildren);
          }
        } else if (visible) {
          flatData.push(treeNode);
        }
      } else {
        var inFocus = !focusNode || focusNode === node || isFocusChild;

        if (flatData && inFocus) {
          flatData.push(treeNode);
        }

        if (hasChildren) {
          var expanded = this._isExpandedById(id) || alwaysExpanded;
          var prevExpanded = prevExpandedNodes[id];

          if (expanded || prevExpanded) {
            children = children || getChildren(node, depth, focusDepth) || []; // If we were previously expanded we need to go down this path in order to generate the byIdMap
            // to fully purge data that is no longer accessible.
            // `null` is passed in for `flatData` so that we do not actually add nodes to your flat data.

            var length = flatData ? flatData.length : 0;

            this._toFlat(children, byIdMap, expanded ? flatData : null, depth + 1, focusDepth + (inFocus ? 1 : 0), index, treeNode, inFocus);

            index += flatData ? flatData.length - length : 0;
          }
        }
      }
    }
  };

  _proto._toObjectMap = function _toObjectMap(boolMap) {
    var _this3 = this;

    return Object.keys(boolMap).reduce(function (map, id) {
      if (boolMap[id] && _this3._byIdMap[id]) {
        map[id] = _this3._byIdMap[id].node;
      }

      return map;
    }, {});
  };

  _proto.scrollToId = function scrollToId(id) {
    var index = this._getIndex(id);

    this._list.scrollTo(index);
  };

  _proto.render = function render() {
    var _this$props6 = this.props,
        onMenu = _this$props6.onMenu,
        data = _this$props6.data,
        getRootNodes = _this$props6.getRootNodes,
        className = _this$props6.className,
        style = _this$props6.style,
        filter = _this$props6.filter,
        emptyFilterState = _this$props6.emptyFilterState,
        itemSizeGetter = _this$props6.itemSizeGetter,
        itemSizeEstimator = _this$props6.itemSizeEstimator,
        maxHeight = _this$props6.maxHeight,
        allowReorder = _this$props6.allowReorder,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props6, ["onMenu", "data", "getRootNodes", "className", "style", "filter", "emptyFilterState", "itemSizeGetter", "itemSizeEstimator", "maxHeight", "allowReorder"]); // Try reduce the number calls to _toFlat() https://jsw.ibm.com/browse/MUI-1489

    if (allowReorder || this._flattenTree) {
      this._data = [];
      this._byIdMap = {};

      this._toFlat(getRootNodes(data), this._byIdMap, this._data);
    }

    this._flattenTree = true;
    this._activeIndex = this._getIndex(this.state.active);
    this._pivotIndex = this._getIndex(this.state.pivot);
    this._lastClickIndex = this._getIndex(this.state.lastClick);
    var listPassthroughProps = getInheritedProps(others, _list["default"]);

    if (emptyFilterState && filter && this._data.length === 0) {
      return emptyFilterState;
    }

    return /*#__PURE__*/_react["default"].createElement(_list["default"], (0, _extends4["default"])({
      virtualized: true,
      "data-tid": "ba-tree__list"
    }, sanitize(others, Tree), listPassthroughProps, {
      ref: this._refList,
      activeIndex: this._activeIndex,
      pivotIndex: this._pivotIndex,
      lastClickIndex: this._lastClickIndex,
      length: this._data.length,
      onExpand: this._onExpand,
      getParentIndex: this._getParentIndex,
      role: "tree",
      itemRenderer: this._itemRenderer,
      isExpanded: this._isExpandedByIndex,
      onMenu: onMenu && this._onMenu,
      onSelectionChange: this._onSelectionChange,
      isSelected: this._isSelected,
      onActiveChange: this._onActiveChange,
      getKey: this._getId,
      getItemId: this._getId,
      hierarchical: true,
      className: className,
      style: (0, _extends4["default"])({
        maxHeight: maxHeight
      }, style),
      itemSizeEstimator: itemSizeEstimator && this._itemSizeEstimator,
      itemSizeGetter: itemSizeGetter && this._itemSizeGetter,
      selectionMark: true
    }));
  };

  return Tree;
}(_react.Component);

exports["default"] = Tree;
(0, _defineProperty2["default"])(Tree, "propTypes", (0, _extends4["default"])({}, sanitize(_list["default"].propTypes, null, 'length'), {
  onActiveChange: _propTypes["default"].func,
  getChildren: _propTypes["default"].func.isRequired,
  getId: _propTypes["default"].func.isRequired,
  getRootNodes: _propTypes["default"].func,
  getHasChildren: _propTypes["default"].func,
  onExpand: _propTypes["default"].func,
  isVisible: _propTypes["default"].func,
  isAlwaysExpanded: _propTypes["default"].func,
  onSelectionChange: _propTypes["default"].func,
  onMenu: _propTypes["default"].func,
  filter: _propTypes["default"].string,
  data: _propTypes["default"].any.isRequired,
  selectedNodes: _propTypes["default"].object,
  defaultSelectedNodes: _propTypes["default"].object,
  expandedNodes: _propTypes["default"].object,
  defaultExpandedNodes: _propTypes["default"].object,
  selectionMode: _propTypes["default"].oneOf(['none', 'disabled', 'single', 'multi']),
  activeNode: _propTypes["default"].any,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  emptyFilterState: _propTypes["default"].node,
  expandedByDefault: _propTypes["default"].bool,
  allowReorder: _propTypes["default"].bool,
  isDragging: _propTypes["default"].bool,
  focusNode: _propTypes["default"].object,
  itemSizeGetter: _propTypes["default"].func,
  itemSizeEstimator: _propTypes["default"].func,

  /** Specifies the maximum height of the tree */
  maxHeight: _propTypes["default"].number
}));
(0, _defineProperty2["default"])(Tree, "defaultProps", {
  getRootNodes: function getRootNodes(nodes) {
    return Array.isArray(nodes) ? nodes : [nodes];
  },
  getChildren: function getChildren(node) {
    return node.children;
  },
  getId: function getId(node) {
    return node.id;
  },
  isAlwaysExpanded: function isAlwaysExpanded() {
    return false;
  },
  isVisible: function isVisible() {
    return true;
  },
  className: '',
  style: {}
});

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = _default;
exports.treeItemDnD = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _reactDnd = __webpack_require__(26);

var _draglayer = _interopRequireDefault(__webpack_require__(91));

var _itemdnd = _interopRequireWildcard(__webpack_require__(46));

var _utils = __webpack_require__(4);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var treeItemDnD = function treeItemDnD(TreeItem, itemType) {
  if (itemType === void 0) {
    itemType = _itemdnd.ITEM_TYPE;
  }

  var options = typeof itemType === 'string' ? {
    dragItemType: itemType,
    dropItemType: itemType
  } : itemType;
  return (0, _itemdnd["default"])(TreeItem, options);
};

exports.treeItemDnD = treeItemDnD;
var omit = _utils.lodash.omit;
var dropTargetMethods = {
  canDrop: function canDrop(props, monitor) {
    if (props.canDrop && (monitor.isOver({
      shallow: true
    }) || props.canFallThrough && props.canFallThrough())) {
      return props.canDrop({
        data: props.data
      }, monitor.getItem(), monitor);
    }

    return false;
  },
  hover: function hover() {},
  drop: function drop(props, monitor) {
    if (props.onDrop && !monitor.didDrop()) {
      props.onDrop({
        data: props.data
      }, monitor.getItem(), monitor);
    }
  }
};

function _default(Tree, itemType, TreeDragLayer) {
  var _dec, _class, _class2, _temp;

  if (itemType === void 0) {
    itemType = _itemdnd.ITEM_TYPE;
  }

  if (TreeDragLayer === void 0) {
    TreeDragLayer = _draglayer["default"];
  }

  var ScrollableTree = (0, _itemdnd.scrollableDnD)(Tree);
  var TreeDnD = (_dec = (0, _reactDnd.DropTarget)(itemType, dropTargetMethods, function (connect, monitor) {
    return {
      connectDropTarget: connect.dropTarget(),
      isActive: function isActive() {
        return monitor.isOver() && monitor.canDrop();
      },
      getDragPosition: function getDragPosition() {
        return monitor.getClientOffset();
      }
    };
  }), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
    (0, _inheritsLoose2["default"])(TreeDnD, _Component);

    function TreeDnD() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
        draggingNodes: []
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_connectToDnD", function (ref) {
        _this._node = _reactDom["default"].findDOMNode(ref);

        _this.props.connectDropTarget(_this._node);

        _this._tree = ref;
        var treeDnDForwardRef = _this.props.treeDnDForwardRef;
        treeDnDForwardRef && treeDnDForwardRef(ref);
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_dragLayerRenderer", function (_ref) {
        var itemProps = _ref.itemProps,
            currentOffset = _ref.currentOffset,
            droppable = _ref.droppable;
        return /*#__PURE__*/_react["default"].createElement(TreeDragLayer, {
          currentOffset: currentOffset,
          droppable: droppable
        }, _this.props.dragLayerRenderer(itemProps, droppable));
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_itemRenderer", function (node, props) {
        var _this$props = _this.props,
            itemRenderer = _this$props.itemRenderer,
            canDrop = _this$props.canDrop,
            onDrop = _this$props.onDrop,
            onItemHover = _this$props.onItemHover;
        var draggingNodes = _this.state.draggingNodes;
        var itemDragging = draggingNodes.indexOf(node) >= 0;
        var treeProps = (0, _extends2["default"])({}, props, {
          dragging: itemDragging,
          canDrop: canDrop,
          onDrop: onDrop,
          canDragNode: _this._canDragNode,
          getDropProps: _this._getDropProps,
          onBeginDrag: _this._onBeginDrag,
          onEndDrag: _this._onEndDrag,
          onHover: onItemHover
        });
        return itemRenderer(node, treeProps);
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_canDragNode", function (itemProps) {
        var canDragNode = _this.props.canDragNode;
        var node = itemProps.node;

        var selected = _this._tree.getSelectedNodes();

        return selected.indexOf(node) !== -1 && (!canDragNode || canDragNode(node));
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBeginDrag", function (itemProps) {
        var data = _this.props.data;
        var node = itemProps.node;

        var selected = _this._tree.getSelectedNodes();

        _this.setState({
          draggingNodes: selected
        });

        var payload = {
          node: node,
          items: selected,
          dragLayerRenderer: _this._dragLayerRenderer,
          data: data
        };
        var newPayload;

        if (_this.props.onBeginDrag) {
          newPayload = _this.props.onBeginDrag(payload);
        }

        return newPayload == null ? payload : newPayload;
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onEndDrag", function () {
        setTimeout(function () {
          _this.setState({
            draggingNodes: []
          });

          _this.props.onEndDrag && _this.props.onEndDrag();
        }, 0);
      });
      return _this;
    }

    var _proto = TreeDnD.prototype;

    _proto._getDropProps = function _getDropProps(_ref2, droppedY) {
      var _ref3;

      var node = _ref2.node,
          data = _ref2.data,
          expanded = _ref2.expanded,
          isAlwaysExpanded = _ref2.isAlwaysExpanded;
      return _ref3 = {
        item: node,
        data: data
      }, _ref3[typeof droppedY === 'boolean' ? 'droppedBelow' : 'droppedYPercent'] = droppedY, _ref3.expanded = expanded || isAlwaysExpanded, _ref3;
    };

    _proto.render = function render() {
      var draggingNodes = this.state.draggingNodes;
      var _this$props2 = this.props,
          selectionMode = _this$props2.selectionMode,
          activeClassName = _this$props2.activeClassName,
          isActive = _this$props2.isActive,
          other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["selectionMode", "activeClassName", "isActive"]);
      var passThroughProps = omit(other, 'className', 'onDrop', 'canDrop', 'dragLayerRenderer', 'theme', 'connectDropTarget', 'onBeginDrag', 'canDragNode', 'onEndDrag', 'canFallThrough', 'onItemHover', 'getDragPosition', 'treeDnDForwardRef');
      var className = this.props.className;

      if (activeClassName && isActive()) {
        className = className ? className + " " + activeClassName : activeClassName;
      }

      return /*#__PURE__*/_react["default"].createElement(ScrollableTree, (0, _extends2["default"])({
        fullHeight: true
      }, passThroughProps, {
        className: className,
        itemRenderer: this._itemRenderer,
        selectionMode: draggingNodes.length && selectionMode !== 'none' ? 'disabled' : selectionMode,
        isDragging: draggingNodes.length,
        ref: this._connectToDnD
      }));
    };

    return TreeDnD;
  }(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
    data: _propTypes["default"].any.isRequired,
    dragLayerRenderer: _propTypes["default"].func,
    canDrop: _propTypes["default"].func,
    isActive: _propTypes["default"].func,
    getDragPosition: _propTypes["default"].func,
    onDrop: _propTypes["default"].func,
    itemRenderer: _propTypes["default"].func.isRequired,
    connectDropTarget: _propTypes["default"].func.isRequired,
    theme: _propTypes["default"].string,
    selectionMode: _propTypes["default"].string,
    activeClassName: _propTypes["default"].string,
    className: _propTypes["default"].string,
    onEndDrag: _propTypes["default"].func,
    onBeginDrag: _propTypes["default"].func,
    canDragNode: _propTypes["default"].func,
    onItemHover: _propTypes["default"].func,
    canFallThrough: _propTypes["default"].func,
    treeDnDForwardRef: _propTypes["default"].func
  }), (0, _defineProperty2["default"])(_class2, "defaultProps", {
    canFallThrough: function canFallThrough() {
      return false;
    }
  }), _temp)) || _class);
  return _react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TreeDnD, (0, _extends2["default"])({}, props, {
      treeDnDForwardRef: ref
    }));
  });
}

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = _interopRequireDefault(__webpack_require__(586));

var _2 = _interopRequireDefault(__webpack_require__(587));

var _button = _interopRequireDefault(__webpack_require__(15));

var _list = __webpack_require__(25);

var _hspacer = _interopRequireDefault(__webpack_require__(92));

var _flexlayout = __webpack_require__(16);

var _utils = __webpack_require__(4);

var _TreeItem = _interopRequireDefault(__webpack_require__(588));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var treeItemClassName = _TreeItem["default"].treeItemClassName.replace(/"/g, '');

var omit = _utils.lodash.omit;
var stopEvent = _utils.event.stopEvent;

var TreeItem = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TreeItem, _Component);

  function TreeItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onExpand", function (e) {
      stopEvent(e);
      var _this$props = _this.props,
          onExpand = _this$props.onExpand,
          index = _this$props.index,
          expanded = _this$props.expanded;
      onExpand && onExpand(index, !expanded);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_stopPropagation", function (e) {
      e.stopPropagation();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMenu", function (x, y, e) {
      var onMenu = _this.props.onMenu;
      onMenu && onMenu(x, y, e);
    });
    return _this;
  }

  var _proto = TreeItem.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        icon = _this$props2.icon,
        depth = _this$props2.depth,
        alwaysExpanded = _this$props2.alwaysExpanded,
        hasChildren = _this$props2.hasChildren,
        expanded = _this$props2.expanded,
        children = _this$props2.children,
        onMenu = _this$props2.onMenu,
        index = _this$props2.index,
        expandTitle = _this$props2.expandTitle,
        pathToRoot = _this$props2.pathToRoot,
        isFocusNode = _this$props2.isFocusNode,
        other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["icon", "depth", "alwaysExpanded", "hasChildren", "expanded", "children", "onMenu", "index", "expandTitle", "pathToRoot", "isFocusNode"]);
    var indent = icon ? 1 : 0;

    if (alwaysExpanded) {
      indent += 2;
    } else if (!hasChildren) {
      indent += 4;
    }

    if (depth != null) {
      indent += depth * 2;
    }

    var passThroughProps = omit(other, 'visible', 'node', 'getSelectedNodes', 'data', 'dragging', 'loading', 'onExpand', 'pathToRoot');
    return /*#__PURE__*/_react["default"].createElement(_list.ListItem, (0, _extends2["default"])({}, passThroughProps, {
      index: index,
      onMenu: onMenu && this._onMenu,
      className: "" + treeItemClassName,
      role: "treeitem",
      "aria-expanded": hasChildren ? expanded : null,
      "data-tid": "treeItem" + pathToRoot
    }), icon, indent > 0 ? /*#__PURE__*/_react["default"].createElement(_hspacer["default"], {
      size: indent
    }) : null, hasChildren && !alwaysExpanded || isFocusNode ? /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
      hasIconOnly: true,
      kind: "ghost",
      size: "small",
      iconDescription: expandTitle,
      "aria-label": expandTitle,
      onMouseDown: this._stopPropagation,
      onTouchEnd: this._stopPropagation,
      onDoubleClick: this._stopPropagation,
      onClick: this._onExpand,
      renderIcon: expanded ? _2["default"] : _["default"],
      "data-tid": "expandTreeItemClickable"
    })) : null, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
      grow: true,
      className: treeItemClassName + "__child-item"
    }, children));
  };

  return TreeItem;
}(_react.Component);

exports["default"] = TreeItem;
(0, _defineProperty2["default"])(TreeItem, "propTypes", {
  depth: _propTypes["default"].number.isRequired,
  length: _propTypes["default"].number.isRequired,
  index: _propTypes["default"].number.isRequired,
  icon: _propTypes["default"].any,
  selected: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired,
  onMenu: _propTypes["default"].func,
  alwaysExpanded: _propTypes["default"].bool,
  expanded: _propTypes["default"].bool,
  onExpand: _propTypes["default"].func,
  hasChildren: _propTypes["default"].bool,
  expandTitle: _propTypes["default"].string,
  pathToRoot: _propTypes["default"].string,
  ellipsisTitle: _propTypes["default"].string,
  isFocusNode: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(TreeItem, "defaultProps", {
  depth: 0
});

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

module.exports = require("@carbon/icons-react/lib/caret--right/16");

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports = require("@carbon/icons-react/lib/caret--down/16");

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(589);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-treeItem__button{position:relative}.ba-common-treeItem .ba-common-listItem-with-right-icon .ba-common-button.is-small .ba-common-svgIcon.is-small.is-pad{padding-left:16px;padding-right:16px}.ba-common-treeItem__child-item{padding:0}[dir=\"ltr\"].ba-common-treeItem__child-item{padding-right:8px}[dir=\"rtl\"].ba-common-treeItem__child-item{padding-right:0;padding-left:8px}[dir=\"ltr\"] .ba-common-treeItem__child-item,.ba-common-treeItem__child-item{padding-right:8px}[dir=\"rtl\"] .ba-common-treeItem__child-item{padding-right:0;padding-left:8px}.ba-common-treeItem__child-item .ba-common-svgIcon.is-small{min-width:16px}.ba-common-treeItem button[data-tid=\"expandTreeItemClickable\"]{border-color:transparent;color:inherit}.ba-common-treeItem button[data-tid=\"expandTreeItemClickable\"] span.bx--assistive-text{visibility:hidden}.ba-common-treeItem button[data-tid=\"expandTreeItemClickable\"].bx--btn::before{content:none}.ba-common-treeItem button[data-tid=\"expandTreeItemClickable\"].bx--btn:focus{border-color:transparent}.mobile .ba-common-treeItem__button.is-tiny{width:18px;height:18px}.ba-common-treeItem .ba-common-svgIcon{transition-duration:0s}\n", ""]);

// exports
exports.locals = {
	"treeItemClassName": "\"ba-common-treeItem\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__91__;

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__92__;

/***/ })

},[[581,0]]]);
});